module.exports = "/shifts/components/publishWarningLaborCost-eeb447.html";